import { IWorkflowNode } from "motw_core/Entity/IWorkflowNode";
import {
    homeNode,
    workflowRepository,
} from "motw_core/Repositories/WorkflowRepository";
import ClientDataProvider from "source/app/services/External/ClientDataProvider/ClientDataProvider";

export async function GetWorkflowNodeMatchesAsync(
    query: string
): Promise<IWorkflowNode[]> {
    const idText = query.startsWith("#") ? query.substring(1) : query;

    if (/^\d+$/.test(idText)) {
        const id = Number.parseInt(idText);
        const node =
            id === homeNode.id
                ? homeNode
                : await workflowRepository.GetNodeById(ClientDataProvider, id);

        return node ? [node] : [];
    }

    const matches = await workflowRepository.GetNodesMatching(
        ClientDataProvider,
        query
    );
    const homeMatches = homeNode.name
        .toLowerCase()
        .includes(query.toLowerCase())
        ? [homeNode]
        : [];

    return [...homeMatches, ...matches];
}
